import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Img } from "@storybook/components";
import React from "react";
import { OutputMessageProps } from "./types";
import { ButtonText } from "../Button";

const OutputMessage: React.FC<OutputMessageProps> = ({ status, onClick, buttonText, descriptionText, icon, labelText, title }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  return (
    <>
      { title && (
        <Typography
          color="primary"
          fontSize={ isMobile ? "1.25rem" : "2rem" }
          fontWeight={ 700 }
          lineHeight={ isMobile ? (21 / 20) : (19 / 16) }
        >
          { title }
        </Typography>
      ) }
      <Box
        sx={ {
          display: "flex",
          justifyContent: "center",
          my: "30px"
        } }
      >
        <Img
          role="img"
          src={ icon }
          alt="Icon"
          width={ 80 }
          height={ 80 }
          loading="lazy"
        />
      </Box>
      <Typography
        variant="h4"
        sx={ {
          textAlign: "center",
          mb: "10px"
        } }
      >
        { labelText }
      </Typography>
      { descriptionText && (
        <Typography
          variant="h6"
          sx={ {
            textAlign: "center",
            mb: "10px"
          } }
        >
          { descriptionText }
        </Typography>
      ) }
      { status && (
        <Stack
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          mt={ 3 }
          sx={ { width: "65%", mx: "auto", marginTop: "30px" } }
        >
          <ButtonText
            variant="outlined"
            onClick={ onClick  && onClick }
          >
            { buttonText }
          </ButtonText>
        </Stack>
      ) }
    </>
  );
};

export default OutputMessage;
